import { Component, Input, NgModule } from '@angular/core';
import { NavigationEnd, ActivatedRoute, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';

function PageHeaderComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelement(1, "i", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r1.backPageUrl);
} }
function PageHeaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, PageHeaderComponent_div_0_div_2_Template, 2, 1, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "h1");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵprojection(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.backPageUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
} }
const _c0 = ["*"];
class PageHeaderComponent {
    constructor(activatedRoute, router) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.title = 'Home';
    }
    ngOnInit() {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd), map(() => this.activatedRoute), map(route => {
            while (route.firstChild)
                route = route.firstChild;
            return route;
        }), filter(route => route.outlet === 'primary'), mergeMap(route => route.data))
            .subscribe((event) => {
            this.title = event && event.pageTitle ? event.pageTitle : '';
            this.backPageUrl = event.backPage ? event.backPage : null;
        });
    }
}
PageHeaderComponent.ɵfac = function PageHeaderComponent_Factory(t) { return new (t || PageHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router)); };
PageHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PageHeaderComponent, selectors: [["app-page-header"]], inputs: { title: "title" }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [["class", "page-header", 4, "ngIf"], [1, "page-header"], [1, "page-title"], ["class", "btn btn-outline btn-default btn-circle btn-sm previous-page", 3, "routerLink", 4, "ngIf"], [1, "page-header-toolbar"], [1, "btn", "btn-outline", "btn-default", "btn-circle", "btn-sm", "previous-page", 3, "routerLink"], [1, "fas", "fa-share"]], template: function PageHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, PageHeaderComponent_div_0_Template, 7, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
    } }, directives: [ɵngcc2.NgIf, ɵngcc1.RouterLink], styles: [".page-header[_ngcontent-%COMP%]{padding-left:20px;display:flex;align-items:center;flex-wrap:wrap;justify-content:space-between;min-height:50px;background:#ffffff}.page-header[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]{display:flex;padding:10px}.page-header[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .previous-page[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;border-radius:50%;height:30px;width:30px;margin-right:20px;padding-right:10px;border:1px solid;box-shadow:0 5px 5px #32323273!important;color:#3598d6!important}.page-header[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .previous-page[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:15px;transform:rotateY(-180deg);-ms-transform:rotateY(-180deg);-webkit-transform:rotateY(-180deg);color:#3598d6!important}.page-header[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   .previous-page[_ngcontent-%COMP%]:hover{background:#ededed!important;border-color:#74788d}.page-header[_ngcontent-%COMP%]   .page-title[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{color:#697882;font-size:21px;font-weight:600;margin-bottom:0}.page-header[_ngcontent-%COMP%]   .page-header-toolbar[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;padding-right:20px}"] });
PageHeaderComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router }
];
PageHeaderComponent.propDecorators = {
    title: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-page-header',
                template: "<div class=\"page-header\" *ngIf=\"title\">\r\n  <div class=\"page-title\">\r\n    <div class=\"btn btn-outline btn-default btn-circle btn-sm previous-page\"\r\n         *ngIf=\"backPageUrl\" [routerLink]=\"backPageUrl\">\r\n      <i class=\"fas fa-share\"></i>\r\n    </div>\r\n    <h1>{{ title }}</h1>\r\n  </div>\r\n  <div class=\"page-header-toolbar\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n",
                styles: [".page-header{padding-left:20px;display:flex;align-items:center;flex-wrap:wrap;justify-content:space-between;min-height:50px;background:#ffffff}.page-header .page-title{display:flex;padding:10px}.page-header .page-title .previous-page{display:flex;align-items:center;justify-content:center;border-radius:50%;height:30px;width:30px;margin-right:20px;padding-right:10px;border:1px solid;box-shadow:0 5px 5px #32323273!important;color:#3598d6!important}.page-header .page-title .previous-page i{font-size:15px;transform:rotateY(-180deg);-ms-transform:rotateY(-180deg);-webkit-transform:rotateY(-180deg);color:#3598d6!important}.page-header .page-title .previous-page:hover{background:#ededed!important;border-color:#74788d}.page-header .page-title h1{color:#697882;font-size:21px;font-weight:600;margin-bottom:0}.page-header .page-header-toolbar{display:flex;justify-content:flex-end;align-items:center;padding-right:20px}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }, { type: ɵngcc1.Router }]; }, { title: [{
            type: Input
        }] }); })();

class PageHeaderModule {
}
PageHeaderModule.ɵfac = function PageHeaderModule_Factory(t) { return new (t || PageHeaderModule)(); };
PageHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PageHeaderModule });
PageHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            RouterModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PageHeaderComponent
                ],
                exports: [
                    PageHeaderComponent
                ],
                imports: [
                    CommonModule,
                    RouterModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageHeaderModule, { declarations: function () { return [PageHeaderComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [PageHeaderComponent]; } }); })();

/*
 * Public API Surface of page-header
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PageHeaderComponent, PageHeaderModule };

